import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './auth/ProtectedRoute';
import AppShell from './app/AppShell';
import LoginPage from './pages/LoginPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ModulePage from './pages/ModulePage';
import SuppliersPage from './features/suppliers/SuppliersPage';
import SupplierProfilePage from './features/suppliers/profile/SupplierProfilePage';
import SettingsPage from './features/settings/SettingsPage';
import UsersPage from './features/users/UsersPage';
import CatalogPage from './features/catalog/CatalogPage';
import ItemDetailPage from './features/catalog/ItemDetailPage';
import RecipesPage from './features/recipes/RecipesPage';
import RecipeFormPage from './features/recipes/RecipeFormPage';
import RecipeCategoriesPage from './features/recipes/RecipeCategoriesPage';
import MenuEngineeringPage from './features/recipes/MenuEngineeringPage';
import MenuAnalysisFormPage from './features/recipes/MenuAnalysisFormPage';
import UsageVariancePage from './features/usage/UsageVariancePage';
import UsageAnalysisFormPage from './features/usage/UsageAnalysisFormPage';
import RequisitionsPage from './features/requisitions/RequisitionsPage';
import RequisitionFormPage from './features/requisitions/RequisitionFormPage';
import RequisitionDetailPage from './features/requisitions/RequisitionDetailPage';
import RequisitionPrintPage from './features/requisitions/RequisitionPrintPage';
import MarketListPage from './features/marketlist/MarketListPage';
import MarketListFormPage from './features/marketlist/MarketListFormPage';
import MarketListDetailPage from './features/marketlist/MarketListDetailPage';
import PurchaseOrdersPage from './features/purchase-orders/PurchaseOrdersPage';
import PurchaseOrderFormPage from './features/purchase-orders/PurchaseOrderFormPage';
import PurchaseOrderDetailPage from './features/purchase-orders/PurchaseOrderDetailPage';
import PurchaseOrderPrintPage from './features/purchase-orders/PurchaseOrderPrintPage';
import ReceivingPage from './features/receiving/ReceivingPage';
import GoodsReceiptDetailPage from './features/receiving/GoodsReceiptDetailPage';
import ReceiveGoodsPage from './features/receiving/ReceiveGoodsPage';
import ReturnsPage from './features/returns/ReturnsPage';
import ReturnFormPage from './features/returns/ReturnFormPage';
import ReturnDetailPage from './features/returns/ReturnDetailPage';
import ReportsPage from './features/reports/ReportsPage';
import StockOnHandPage from './features/inventory/StockOnHandPage';
import CountsPage from './features/counts/CountsPage';
import CountFormPage from './features/counts/CountFormPage';
import CountDetailPage from './features/counts/CountDetailPage';
import TransfersPage from './features/transfers/TransfersPage';
import TransferFormPage from './features/transfers/TransferFormPage';
import TransferDetailPage from './features/transfers/TransferDetailPage';
import AdjustmentsPage from './features/adjustments/AdjustmentsPage';
import AdjustmentFormPage from './features/adjustments/AdjustmentFormPage';
import AdjustmentDetailPage from './features/adjustments/AdjustmentDetailPage';
import GoodsReceiptPrintPage from './features/receiving/GoodsReceiptPrintPage';
import InvoicesPage from './features/invoices/InvoicesPage';
import InvoiceFormPage from './features/invoices/InvoiceFormPage';
import InvoiceDetailPage from './features/invoices/InvoiceDetailPage';
import BudgetsPage from './features/budgets/BudgetsPage';
import AccountPage from './features/account/AccountPage';

const MODULE_ROUTES = [];

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Standalone print views — outside the app shell for a clean document. */}
      <Route
        path="/requisitions/:id/print"
        element={
          <ProtectedRoute>
            <RequisitionPrintPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/purchase-orders/:id/print"
        element={
          <ProtectedRoute>
            <PurchaseOrderPrintPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/receiving/:id/print"
        element={
          <ProtectedRoute>
            <GoodsReceiptPrintPage />
          </ProtectedRoute>
        }
      />


      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="suppliers" element={<SuppliersPage />} />
        <Route path="suppliers/:id" element={<SupplierProfilePage />} />
        <Route path="catalog" element={<CatalogPage />} />
        <Route path="catalog/items/:id" element={<ItemDetailPage />} />
        <Route path="recipes" element={<RecipesPage />} />
        <Route path="recipes/categories" element={<RecipeCategoriesPage />} />
        <Route path="recipes/new" element={<RecipeFormPage />} />
        <Route path="recipes/:id" element={<RecipeFormPage />} />
        <Route path="menu-engineering" element={<MenuEngineeringPage />} />
        <Route path="menu-engineering/new" element={<MenuAnalysisFormPage />} />
        <Route path="menu-engineering/:id" element={<MenuAnalysisFormPage />} />
        <Route path="usage-variance" element={<UsageVariancePage />} />
        <Route path="usage-variance/new" element={<UsageAnalysisFormPage />} />
        <Route path="usage-variance/:id" element={<UsageAnalysisFormPage />} />
        <Route path="requisitions" element={<RequisitionsPage />} />
        <Route path="requisitions/new" element={<RequisitionFormPage />} />
        <Route path="requisitions/:id" element={<RequisitionDetailPage />} />
        <Route path="requisitions/:id/edit" element={<RequisitionFormPage />} />
        <Route path="market-list" element={<MarketListPage />} />
        <Route path="market-list/new" element={<MarketListFormPage />} />
        <Route path="market-list/:id" element={<MarketListDetailPage />} />
        <Route path="market-list/:id/edit" element={<MarketListFormPage />} />
        <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="purchase-orders/new" element={<PurchaseOrderFormPage />} />
        <Route path="purchase-orders/:id" element={<PurchaseOrderDetailPage />} />
        <Route path="purchase-orders/:id/edit" element={<PurchaseOrderFormPage />} />
        <Route path="purchase-orders/:id/receive" element={<ReceiveGoodsPage />} />
        <Route path="receiving" element={<ReceivingPage />} />
        <Route path="receiving/:id/edit" element={<ReceiveGoodsPage />} />
        <Route path="receiving/:id" element={<GoodsReceiptDetailPage />} />
        <Route path="purchase-orders/:id/return" element={<ReturnFormPage />} />
        <Route path="returns" element={<ReturnsPage />} />
        <Route path="returns/new" element={<ReturnFormPage />} />
        <Route path="returns/:id" element={<ReturnDetailPage />} />
        <Route path="inventory" element={<StockOnHandPage />} />
        <Route path="counts" element={<CountsPage />} />
        <Route path="counts/new" element={<CountFormPage />} />
        <Route path="counts/:id" element={<CountDetailPage />} />
        <Route path="transfers" element={<TransfersPage />} />
        <Route path="transfers/new" element={<TransferFormPage />} />
        <Route path="transfers/:id" element={<TransferDetailPage />} />
        <Route path="adjustments" element={<AdjustmentsPage />} />
        <Route path="adjustments/new" element={<AdjustmentFormPage />} />
        <Route path="adjustments/:id" element={<AdjustmentDetailPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/new" element={<InvoiceFormPage />} />
        <Route path="invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="budgets" element={<BudgetsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="account" element={<AccountPage />} />
        {MODULE_ROUTES.map((m) => (
          <Route
            key={m.path}
            path={m.path}
            element={
              <ModulePage title={m.title} description={m.description} icon={m.icon} primaryAction={m.action} />
            }
          />
        ))}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
